import _ from 'lodash';
import { TableVizPropVersion } from '../../types/prism';
import { TableClientStateV1Schema } from '../types/v1';
export const upgradeV1ToV2 = (tableModel) => {
    const { vizProp: clientState } = tableModel;
    const { columnProperties, density, showTableFooter, wrapTableHeader, theme, } = clientState;
    const newColumnProperties = {};
    columnProperties.forEach(column => {
        const { columnId, columnProperty } = column;
        newColumnProperties[columnId] = {
            ...columnProperty,
            showSummary: true,
        };
    });
    const newDisplayProperties = {
        theme,
        density,
        wrapHeader: wrapTableHeader,
        showFooter: showTableFooter,
    };
    return {
        columnProperties: newColumnProperties,
        displayProperties: newDisplayProperties,
    };
};
export const upgraderFn = (tableModel) => {
    const { vizProp: clientState } = tableModel;
    const validateClientStateV1Schema = TableClientStateV1Schema.validate(clientState);
    if (validateClientStateV1Schema.error) {
        throw new Error(`[validateClientStateV1Schema] : ${validateClientStateV1Schema.error.message}`);
    }
    const clientStateVersion = _.get(clientState, 'tableVizPropVersion');
    if (clientStateVersion !== TableVizPropVersion.V1) {
        throw new Error(`incompatible client state received in table upgrade path for v1 to v2 with version no:${clientStateVersion}`);
    }
    return upgradeV1ToV2(tableModel);
};
//# sourceMappingURL=v1-to-v2.js.map